import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../services/api";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
    const [user, setUser]       = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const t = localStorage.getItem("kb_admin_token");
        if (t) {
            api.me()
                .then(setUser)
                .catch(() => localStorage.removeItem("kb_admin_token"))
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (username, password) => {
        const data = await api.login(username, password);
        if (data.needs_2fa) {
            return { needs_2fa: true, partial_token: data.partial_token };
        }
        localStorage.setItem("kb_admin_token", data.access_token);
        const me = await api.me();
        setUser(me);
        return { needs_2fa: false };
    };

    const login2fa = async (partial_token, code) => {
        const data = await api.login2fa(partial_token, code);
        localStorage.setItem("kb_admin_token", data.access_token);
        const me = await api.me();
        setUser(me);
    };

    const logout = () => {
        localStorage.removeItem("kb_admin_token");
        setUser(null);
    };

    return (
        <AdminContext.Provider value={{ user, loading, login, login2fa, logout }}>
            {children}
        </AdminContext.Provider>
    );
}

export const useAdmin = () => useContext(AdminContext);
